import LoadingDots from 'components/LoadingDots';
import useGoogleMaps from 'hooks/UseGoogleMaps';
import React from 'react';

function EnsureGoogleMapsLoaded({ children }: { children: any }) {
  const isLoaded = useGoogleMaps();

  if (!isLoaded) {
    return <LoadingDots />;
  }

  return children;
}

export default EnsureGoogleMapsLoaded;
